import React from "react";
import "./SelectFilter.css";

const SelectFilter = ({
  value,
  onChange,
  options,
  ariaLabel,
  wrapperClassName = "",
  iconClassName = "",
  selectClassName = "",
}) => (
  <div className={["select-filter", wrapperClassName].filter(Boolean).join(" ")}>
    {iconClassName ? <i className={iconClassName} aria-hidden /> : null}
    <select
      className={selectClassName}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
    >
      {options.map((opt) => (
        <option key={String(opt.value)} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default SelectFilter;
